<div class="dashboard_trending_part" #trendingComponentIdentifier [ngClass]="isRegulatorComponentShow == true ? 'scrollon' : ''">
  <app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
  <div class="row">
    <div class="col-12">
      <div class="card top-bar-card d-flex flex-wrap align-items-center justify-content-between" #topbarIndentifier>

        <div class="d-flex input-field-part">
          <div class="form-group form-group-sm">
            <div class="left inline control-label d-none d-sm-block mb-1">Top Types</div>
            <div class="input-group input-group-sm">
              <select class="form-control form-control-sm border-bottom" [(ngModel)]="savedFilterTopTypes"
                (change)="changeTopTypes()">
                <option value=10>Top 10</option>
                <option value=20>Top 20</option>
                <option value=30>Top 30</option>
                <option value=40>Top 40</option>
                <option value=50>Top 50</option>
              </select>
            </div>
          </div>
          <div class="form-group form-group-sm">
            <div class="left inline control-label d-none d-sm-block mb-1">Regulator</div>
            <div class="input-group trending-input-group input-group-sm form-group">
              <mat-chip-grid #regulatorList>
                <ng-container *ngFor="let regulator of topicInput.regulator">
                  <div class="matchip-list">
                    <mat-chip-row [selectable]="selectable" [removable]="removable" (removed)="removeRegulator(regulator)">
                      {{regulator}}
                      <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
                    </mat-chip-row>
                  </div>
                  
                </ng-container>
                <input class="form-control custom-input-control form-control-sm mat-autodd-input border-bottom" #regulatorInput
                  [formControl]="searchRegulatorCntrl" [matAutocomplete]="regulatorAutocomplete"
                  [matChipInputFor]="regulatorList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur">
              </mat-chip-grid>
              <mat-autocomplete #regulatorAutocomplete="matAutocomplete"
                (optionSelected)="selectedRegulatorEvent($event)">
                <mat-option *ngFor="let regulator of searchedRegulators" [title]="regulator.name"
                  [value]="regulator.value">
                  {{regulator.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <div class="form-group form-group-sm">
            <div class="left inline control-label d-none d-sm-block mb-1">Country</div>
            <div class="input-group trending-input-group input-group-sm form-group">
              <mat-chip-grid #countryList>
                <ng-container *ngFor="let country of topicInput.country">
                  <div class="matchip-list">
                    <mat-chip-row [selectable]="selectable" [removable]="removable" (removed)="removeCountry(country)">
                      {{country}}
                      <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
                    </mat-chip-row>
                  </div>
                </ng-container>
                <input class="form-control form-control-sm custom-input-control mat-autodd-input border-bottom" #countryInput
                  [formControl]="searchCountryCntrl" [matAutocomplete]="countryAutocomplete"
                  [matChipInputFor]="countryList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur">
              </mat-chip-grid>
              <mat-autocomplete #countryAutocomplete="matAutocomplete" (optionSelected)="selectedCountryEvent($event)">
                <mat-option *ngFor="let country of searchedCountries" [title]="country.name" [value]="country.value">
                  {{country.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <div class="form-group form-group-sm">
            <div class="left inline control-label d-none d-sm-block mb-1">Trending Topics</div>
            <div class="input-group trending-input-group  input-group-sm form-group">
              <mat-chip-grid #trendingTopicList>
                <ng-container *ngFor="let topic of topicInput.trendingTopics">
                  <div class="matchip-list">
                    <mat-chip-row [selectable]="selectable" [removable]="removable" (removed)="removeTrendingTopic(topic)">
                      {{topic}}
                      <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
                    </mat-chip-row>
                  </div>
                </ng-container>
                <input class="form-control custom-input-control form-control-sm mat-autodd-input border-bottom" #trendingTopicInput
                  [formControl]="searchTrendingTopicsCntrl" [matAutocomplete]="trendingTopicAutocomplete"
                  [matChipInputFor]="trendingTopicList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur">
              </mat-chip-grid>
              <mat-autocomplete #trendingTopicAutocomplete="matAutocomplete" (optionSelected)="selectedTrendingTopicEvent($event)">
                <mat-option *ngFor="let topics of searchedTrendingTopics" [title]="topics" [value]="topics">
                  {{topics}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <div class="form-group form-group-sm">
            <div class="left inline control-label d-none d-sm-block mb-1">Filters</div>
            <div class="input-group input-group-sm">
              <select class="form-control form-control-sm border-bottom" [(ngModel)]="savedFilterDate"
                (change)="applyDateFilters($event.target.value)">
                <option value="Last7">Last 7 Days</option>
                <option value="Last30">Last 30 Days</option>
                <option value="DateRange">Date Range</option>
              </select>
            </div>
          </div>
          <div class="form-group mt-1 w-auto form-group-sm" *ngIf="isShowDateRange">
            <div class="left inline control-label d-none d-sm-block mb-1">Date Range</div>
            <mat-form-field>
              <mat-date-range-input [rangePicker]="picker" (click)="picker.open()">
                <input matStartDate matInput placeholder="Start date" [(ngModel)]="fromDate">
                <input matEndDate matInput placeholder="End date" [(ngModel)]="toDate" (dateChange)="applyDateRange()">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
          </div>
          <button class="btn btn-primary search_btn" (click)="geTredingTopics()"><i class="fa fa-search"
              aria-hidden="true"></i></button>
        </div>
      </div>
    </div>
    <div class="col-12 mb-2">
      <app-progress-bar [isLoading]="isLoadingRegulations"></app-progress-bar>
    </div>

    <ng-container *ngIf="chartData.length>0" #chartAreaIdentifire>
      <div class="col-xl-12 col-lg-12">
        <div class="card deafult-card mb-4 p-0 card-90">
          <apx-chart [series]="areaChartOptions.series" [chart]="areaChartOptions.chart"
            [xaxis]="areaChartOptions.xaxis" [stroke]="areaChartOptions.stroke"
            [dataLabels]="areaChartOptions.dataLabels"></apx-chart>
        </div>
      </div>
      <div class="col-xl-4 col-lg-6">
        <div class="card deafult-card p-0">
          <div style="text-align:center">
            <apx-chart [series]="barChartOptions.series" [chart]="barChartOptions.chart" [xaxis]="barChartOptions.xaxis"
              [title]="barChartOptions.title"></apx-chart>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-6">
        <div class="card deafult-card p-0">
          <angular-d3-cloud [data]="cloudData" [height]="this.othersChartHeightPixel" [width]="450" [padding]="5"
            font="serif" [autoFill]="true" [animations]="true"></angular-d3-cloud>
        </div>
      </div>
      <div class="col-xl-4 col-lg-6">
        <div class="card deafult-card py-0 px-3">
          <div style="text-align:center">
            <!-- <div id="chart"> -->
            <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart"
              [dataLabels]="chartOptions.dataLabels" [plotOptions]="chartOptions.plotOptions"
              [title]="chartOptions.title" [colors]="chartOptions.colors"></apx-chart>
            <!-- </div> -->
          </div>
        </div>
      </div>
    </ng-container>
    <div class="col-12" *ngIf="chartData.length==0">
      <div class="no_data_dashboard">
        <h3>No Data Available</h3>
      </div>
    </div>
    <div class="col-12"  *ngIf="isRegulatorComponentShow">
      <app-change-viewer [callingLocation]="'trendingDashboard'" [trndingTopicsRegulationFilter]="trndingTopicsRegulationFilter"  [someInput]="selectedBarTopic"></app-change-viewer>
    </div>
  </div>
</div>